import LanguageSelector from '@plone/volto/components/theme/LanguageSelector/LanguageSelector';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import { Link as ReactAriaLink } from 'react-aria-components';
import facebokSvg from '../../../../../icons/Facebookfhnw.svg';
import instagramSvg from '../../../../../icons/instagramfhnw.svg';
import youtubeSvg from '../../../../../icons/youtubefhnw.svg';
import linkedinSvg from '../../../../../icons/linkdein.svg';
import blueskySvg from '../../../../../icons/bluesky.svg';
import { NavItem } from '@fhnw/types/navItem';

interface NavigationFooterProps {
  token: string;
  metaNav: NavItem[];
  toggleMobileMenu?: () => void;
}

export const NavigationFooter: React.FC<NavigationFooterProps> = ({
  metaNav,
  toggleMobileMenu,
}) => (
  <div className="bottom-section">
    <LanguageSelector />
    <div className="bottom-links-container">
      {metaNav?.map((item: NavItem) => (
        <UniversalLink
          key={item['@id']}
          href={item.remoteUrl}
          openLinkInNewTab={false}
          onClick={toggleMobileMenu}
        >
          {item.title}
        </UniversalLink>
      ))}
    </div>
    <div className="social-media-container">
      {[
        {
          href: 'https://www.facebook.com/fhnw.ch',
          label: 'FHNW on Facebook',
          icon: facebokSvg,
        },
        {
          href: 'https://www.instagram.com/fhnw.ch/',
          label: 'FHNW on Instagram',
          icon: instagramSvg,
        },
        {
          href: 'https://bsky.app/profile/did:plc:xmrtqghqhfsgbif5pzjbsxeo',
          label: 'FHNW on Bluesky',
          icon: blueskySvg,
        },
        {
          href: 'https://www.linkedin.com/school/fachhochschule-nordwestschweiz-fhnw/',
          label: 'FHNW on LinkedIn',
          icon: linkedinSvg,
        },
        {
          href: 'https://www.youtube.com/@FHNW',
          label: 'FHNW on YouTube',
          icon: youtubeSvg,
        },
      ].map(({ href, label, icon }, index) => (
        <ReactAriaLink
          key={index}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          className="logo-link"
        >
          <Icon name={icon} size="30px" />
        </ReactAriaLink>
      ))}
    </div>
  </div>
);
